import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { LOGIN } from "../../Auth/Routes";

const PrivateRoute = (props) => {
    const isUserLoggedIn = useSelector(
      (state) => state.login.isLoginApiSuccess
    );
  if (!isUserLoggedIn) {
    return <Redirect to={LOGIN} />;
  }
  return props.component;
};

PrivateRoute.propTypes = {
  component: PropTypes.node,
};

export default PrivateRoute;
